import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import ReactPlayer from 'react-player'
// @ts-ignore
import { Scrollama, Step } from 'react-scrollama'
import SVG, { Props as SVGProps } from 'react-inlinesvg'
import screenfull from 'screenfull'
import { device } from '../breakpoints'

const VideoModule: FC<{
  src: string
  legend: string
}> = ({ src, legend }): ReactElement => {
  const [muted, setMuted] = useState(true)
  const [playing, setPlaying] = useState(false)
  const [player, setPlayer] = useState<ReactPlayer | null>(null)
  const [progress, setProgress] = useState(0)
  const [duration, setDuration] = useState(0)
  const [videoReady, setVideoReady] = useState(false)
  const [videoRef, setVideoRef] = useState<HTMLDivElement | null>(null)

  console.log('Video src:', src, 'legend:', legend)

  const handleWaypointEnter = () => {
    console.log('ENTER')
    setPlaying(true)
  }

  const handleWaypointLeave = () => {
    console.log('LEAVE')
    setPlaying(false)
  }

  const handleOnProgress = (e: any) => {
    setProgress(e.played)
  }

  const handleDuration = (duration: number) => {
    setDuration(duration)
  }

  const videoContentSpaceLeft = videoRef
    ? window.innerHeight - videoRef.getBoundingClientRect().height
    : 0

  return (
    <Container>
      <Content
        style={{
          marginTop: videoContentSpaceLeft * -0.5,
          marginBottom: videoContentSpaceLeft * -0.5,
        }}
      >
        <Scrollama
          onStepEnter={handleWaypointEnter}
          onStepExit={handleWaypointLeave}
          offset={0}
        >
          <Step data={1}>
            <VideoContainer
              onClick={() => {
                setPlaying(true)
              }}
            >
              <VideoInner ref={setVideoRef}>
                <VideoPlayer active={playing}>
                  <Buttons>
                    <ReplayIcon
                      onClick={() => {
                        if (player) {
                          player.seekTo(0)
                        }
                      }}
                    >
                      <StyledSVG
                        src={require(`./replay-icon.svg`).default}
                        title='Menu'
                        color='#202346'
                      />
                    </ReplayIcon>
                    <UnmuteButtonContainer>
                      <UnmuteButton
                        onClick={() => {
                          console.log('click! muted?', muted)
                          if (muted) {
                            setPlaying(true)
                          }
                          setMuted(!muted)
                        }}
                      >
                        <UnmuteButtonIcon>
                          <StyledSVG
                            src={require(`./sound-icon${
                              muted ? '-muted' : ''
                            }.svg`)}
                            title='Menu'
                            color='#202346'
                          />
                        </UnmuteButtonIcon>
                      </UnmuteButton>
                    </UnmuteButtonContainer>
                  </Buttons>

                  <ReactPlayer
                    onReady={() => {
                      setVideoReady(true)
                    }}
                    onDuration={handleDuration}
                    onProgress={handleOnProgress}
                    ref={setPlayer}
                    height={'auto'}
                    width={'100%'}
                    muted={muted}
                    playsinline
                    playing={playing}
                    url={src}
                    className='video player'
                    loop
                  />
                  <PlayStateContainer>
                    <Line progress={progress}></Line>
                  </PlayStateContainer>
                </VideoPlayer>

                {/* <Legend>{legend}</Legend> */}
              </VideoInner>
            </VideoContainer>
          </Step>
        </Scrollama>
      </Content>
    </Container>
  )
}

const VideoInner = styled.div`
  position: relative;
`

const UnmuteButtonIcon = styled.div`
  height: 20px;
  line-height: 0;
  display: inline-block;
`

const PlayStateContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
`

const Line = styled.div<{ progress: number }>`
  width: ${({ progress }) => progress * 100}%;
  height: 4px;
  background-color: #ffe462;
`

const StyledSVG = styled(SVG)<SVGProps>`
  height: 100%;
  width: auto;
  & path,
  line,
  circle,
  rect,
  polyline {
    fill: ${({ color }) => color} !important;
    stroke-width: 0;
  }
`

const Buttons = styled.div`
  position: absolute;
  z-index: 1;
  display: flex;
  top: 20px;
  right: 20px;
`

const Container = styled.div`
  position: relative;
  background-color: #222233;
  background-color: transparent; // remove bg
  font-family: var(--font-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  min-height: 100vh; // instead of 150vh
  color: white;
  padding: 10px 0; // instead of 60px 0
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Content = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Legend = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.5rem;
  color: #ffffff;
  line-height: 2.1rem;
  display: flex;
  padding-top: 1.5rem;
`
const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 100vh;
  padding: 20px;
  box-sizing: border-box;
  line-height: 0;
`

const VideoPlayer = styled.div<{ active: boolean }>`
  position: relative;
  transition: transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
  transform: ${({ active }) => (active ? 'scale(1)' : 'scale(0.9)')};
  opacity: ${({ active }) => (active ? '1' : '0.5')};
`

const UnmuteButtonContainer = styled.div`
  position: relative;
`

const UnmuteButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #ffe462;
  color: #202346;
  border: none;
  outline: none;
  width: 50px;
  height: 50px;
  border-radius: 50px;
  cursor: pointer;
  font-family: var(--font-sans-serif);
  font-size: 0.75em;
  font-weight: 700;
`

const ReplayIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background-color: #ffe462;
  border: none;
  outline: none;
  border-radius: 50px;
  cursor: pointer;
  font-family: var(--font-sans-serif);
  font-size: 0.75em;
  font-weight: 700;
  width: 50px;
  height: 50px;
  margin-right: 10px;

  ${StyledSVG} {
    width: 20px;
    height: auto;
  }
`

export default VideoModule
